import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Quiz from "../pages/quiz/page";
import Processing from "../pages/processing/page";
import Storage from "../pages/storage/page";
import Transport from "../pages/transport/page";
import Wholesale from "../pages/wholesale/page";
import Retail from "../pages/retail/page";
import WhyUs from "../pages/why-us/page";
import Company from "../pages/company/page";
import Careers from "../pages/careers/page";
import Contact from "../pages/contact/page";
import Privacy from "../pages/privacy/page";
import Terms from "../pages/terms/page";
import Cookies from "../pages/cookies/page";
import SignIn from "../pages/signin/page";
import Sustainability from "../pages/sustainability/page";

const routes: RouteObject[] = [
  { path: "/", element: <Home /> },
  { path: "/quiz", element: <Quiz /> },
  { path: "/processing", element: <Processing /> },
  { path: "/storage", element: <Storage /> },
  { path: "/transport", element: <Transport /> },
  { path: "/wholesale", element: <Wholesale /> },
  { path: "/retail", element: <Retail /> },
  { path: "/why-us", element: <WhyUs /> },
  { path: "/company", element: <Company /> },
  { path: "/careers", element: <Careers /> },
  { path: "/contact", element: <Contact /> },
  { path: "/privacy", element: <Privacy /> },
  { path: "/terms", element: <Terms /> },
  { path: "/cookies", element: <Cookies /> },
  { path: "/signin", element: <SignIn /> },
  { path: "/sustainability", element: <Sustainability /> },
  { path: "*", element: <NotFound /> },
];

export default routes;